import {Breadcrumb, Spin} from 'antd';
import {useSelector} from 'react-redux';
import {Link, useParams} from 'react-router-dom';

import {RqGetAllProducts} from '../../reactQuery/apis';
import {selectAuth} from '../../redux/selectors';

import {ImageSection} from './ImageSection';
import {ProductInformation} from './ProductInformation';
import {RelatedProducts} from './RelatedProducts';

const ProductDetails = () => {
  const {id} = useParams();

  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;

  const {data: allProducts, isLoading, error} = RqGetAllProducts(token);
  
  const product = location.state?.product || allProducts?.find(product => product.id === id);

  const relatedProducts = allProducts?.filter(
    item => item.jewelryType === product.jewelryType && item.id !== product.id,
  );

  const breadcrumbItems = product ? [
    {title: <Link to={'/'}>Home</Link>},
    {title: <Link to={'/product'}>Products</Link>},
    {title: product.productName},
  ] : [];

  if (!product) {return <div>Product not found</div>;}
  if (isLoading) {return <Spin />;}
  if (error) {return <div>Error: {error.message}</div>;}

  return (
    <div className={'flex flex-col justify-center items-center lg:px-20 lg:py-10 w-full'}>
      <div className={'w-full max-w-6xl'}>
        <div className={' w-full justify-start mb-3'}>
          <Breadcrumb
            separator={'>'}
            items={breadcrumbItems}
            className={'lg:block hidden text-base text-primary-900'}
          />
        </div>
        <div className={'flex lg:flex-row flex-col justify-center items-center max-w-6xl'}>   
          <div className={'lg:w-1/2 w-full lg:sticky top-4 lg:p-0 p-3 self-start mt-5'}>
            <ImageSection data={product} />
          </div>
          <div className={'lg:w-1/2 w-full lg:pl-8 mt-5 lg:p-0 p-3'}>
            <ProductInformation data={product} />
          </div>
        </div>
        {relatedProducts?.length > 0 && (
          <div className={'w-full lg:mt-10 mt-5 lg:p-0 p-3'}>
            <RelatedProducts products={relatedProducts} currentProduct={product} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDetails;
